__turbopack_context__.v({
  "box-form": "sC8Nkq_box-form",
  "container": "sC8Nkq_container",
  "white-container": "sC8Nkq_white-container",
  "wider-container": "sC8Nkq_wider-container",
});
